// extracted by mini-css-extract-plugin
export default {"logoImage":"Logo__logoImage--1aY","logo":"Logo__logo--2C6","logoCenter":"Logo__logoCenter--z56","logoLink":"Logo__logoLink--1aW"};